const PROJECT_KEY = 'project';
const HIDE_SIDEBAR_QUERY_KEY = 'hide-sidebar';

export { PROJECT_KEY, HIDE_SIDEBAR_QUERY_KEY };
